import { ChevronLeft, ChevronRight } from "lucide-react";

export function PaginationControls({ page, pageSize, count, totalCount, hasNext, loading, onPrevious, onNext }: {
  page: number;
  pageSize: number;
  count: number;
  totalCount?: number | null;
  hasNext: boolean;
  loading: boolean;
  onPrevious: () => void;
  onNext: () => void;
}) {
  const start = count ? (page - 1) * pageSize + 1 : 0;
  const end = count ? start + count - 1 : 0;
  const range = totalCount === undefined || totalCount === null
    ? count ? `${start}–${end}` : "No rows"
    : `${start}–${end} of ${totalCount.toLocaleString()}`;
  return <nav className="pagination-bar" aria-label="Table pagination">
    <span>{range}<small>Page {page}</small></span>
    <div>
      <button className="secondary-button" onClick={onPrevious} disabled={loading || page === 1}><ChevronLeft size={15} />Previous</button>
      <button className="secondary-button" onClick={onNext} disabled={loading || !hasNext}>Next<ChevronRight size={15} /></button>
    </div>
  </nav>;
}
